export const APP_BUILDER_MODULE_ID = 3;

// GET THE ENVIRONMENT BASED ON THE DOMAIN
export const ENVIRONMENT = {
  AMPLIFY: "myamplify",
  MY_PARISH_SOFT: "myparishsoft",
  LEGACY: "legacy",
  MINISTRY_ONE: "ministryone",
  LOCAL: "myamplify", // Set the name which you want to load - ex. myamplify
};

export const NON_ALLOWED_PEOPLEMODULES_ENVS = [ENVIRONMENT.MY_PARISH_SOFT];

export const APP_TITLE = {
  [ENVIRONMENT.AMPLIFY]: "Ministry Brands Amplify | Mobile App",
  [ENVIRONMENT.MY_PARISH_SOFT]: "Parishsoft | Mobile App",
  [ENVIRONMENT.LEGACY]: "MinistryOne | App Builder",
  [ENVIRONMENT.MINISTRY_ONE]: "MinistryOne | App Builder",
};

export const HTTP_STATUS_CODE = {
  FORBIDDEN : 403,
  INTERNAL_SERVER_ERROR : 500,
  UNAUTHORIZED : 401,
  SUCCESS: 200
}